import { render, staticRenderFns } from "./CustomizeMetalN.vue?vue&type=template&id=c878d9fe&scoped=true"
import script from "./CustomizeMetalN.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalN.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalN.vue?vue&type=style&index=0&id=c878d9fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c878d9fe",
  null
  
)

export default component.exports